const buttonUp = document.querySelector('.buttonUp');

window.addEventListener('scroll', () => {
  if (window.scrollY > 900) {
    buttonUp.style.display = 'block';
  } else {
    buttonUp.style.display = 'none';
  }
});

buttonUp.addEventListener('click', () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
});
